import TablePage from "./TablePage";

export default TablePage;
